"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../../../../common/helpers/time");
var EMPTY_NOTE = function () { return ({
    content: "",
    allowed_roles: {
        students: false,
        instructors: false,
        administrators: true,
        staff: true,
    },
}); };
var AdminStudentViewNotesController = /** @class */ (function () {
    function AdminStudentViewNotesController($stateParams, UserService, $sce, FlashService, student, VueStoreFactory, $q) {
        this.handleAddNoteChange = this.handleAddNoteChange.bind(this);
        this.studentNotesPageChanged = this.studentNotesPageChanged.bind(this);
        this.addNote = this.addNote.bind(this);
        this.getRole = this.getRole.bind(this);
        this.$stateParams = $stateParams;
        this.student = student;
        this.VueStoreFactory = VueStoreFactory;
        this.$q = $q;
        this.$sce = $sce;
        this.currentUser = UserService.getCurrentUser();
        this.FlashService = FlashService;
        this.submitting = false;
        this.note = EMPTY_NOTE();
        this.studentNotes = VueStoreFactory.state.studentNotes;
        this.notesPage = 1;
        this.loadNotes(1);
    }
    AdminStudentViewNotesController.prototype.loadNotes = function (page) {
        var _this = this;
        this.submitting = true;
        return this.$q
            .when(this.VueStoreFactory.dispatch("studentNotes/GET_STUDENT_NOTES", {
            studentId: this.student.id,
            page: page,
        }))
            .then(function () {
            _this.notesPage = _this.studentNotes.currentPage;
        })
            .finally(function () {
            _this.submitting = false;
        });
    };
    AdminStudentViewNotesController.prototype.formatNoteContent = function (note) {
        return this.$sce.trustAsHtml(note);
    };
    AdminStudentViewNotesController.prototype.handleAddNoteChange = function (data) {
        this.note.content = data.html;
    };
    AdminStudentViewNotesController.prototype.deleteNote = function (note) {
        var _this = this;
        this.submitting = true;
        this.$q
            .when(this.VueStoreFactory.dispatch("studentNotes/REMOVE_STUDENT_NOTE", {
            studentId: this.student.id,
            noteId: note.id,
        }))
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.notesPage = _this.studentNotes.currentPage;
        })
            .finally(function () {
            _this.submitting = false;
        });
    };
    AdminStudentViewNotesController.prototype.getRole = function (role) {
        if (role === 1) {
            return "Students";
        }
        if (role === 3) {
            return "Instructors";
        }
        if (role === 4) {
            return "Owners";
        }
        if (role === 5) {
            return "Administrators";
        }
        if (role === 9) {
            return "Staff";
        }
        return "Owner";
    };
    AdminStudentViewNotesController.prototype.addNote = function () {
        var _this = this;
        this.submitting = true;
        var note = this.note;
        // Clear the editor straight away rather than after the refetch round trip.
        this.note = EMPTY_NOTE();
        this.$q
            .when(this.VueStoreFactory.dispatch("studentNotes/ADD_STUDENT_NOTE", {
            studentId: this.student.id,
            note: note,
        }))
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.notesPage = _this.studentNotes.currentPage;
        })
            .catch(function () {
            // Give the admin their note back so they don't lose what they typed.
            _this.note = note;
        })
            .finally(function () {
            _this.submitting = false;
        });
    };
    AdminStudentViewNotesController.prototype.studentNotesPageChanged = function () {
        this.loadNotes(this.notesPage);
    };
    AdminStudentViewNotesController.prototype.getStudentAge = function () {
        if (this.student === null) {
            return 100;
        }
        if (typeof this.student.usermeta === "undefined") {
            return 100;
        }
        if (typeof this.student.usermeta.dob === "undefined") {
            return 100;
        }
        var dob = (0, time_1.parseDate)(this.student.usermeta.dob);
        var today = new Date();
        var age = today.getFullYear() - dob.getFullYear();
        var monthDiff = today.getMonth() - dob.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
            age--;
        }
        return age;
    };
    return AdminStudentViewNotesController;
}());
AdminStudentViewNotesController.$inject = [
    "$stateParams",
    "UserService",
    "$sce",
    "FlashService",
    "student",
    "VueStoreFactory",
    "$q",
];
exports.default = AdminStudentViewNotesController;
